/**
 * SSE stream parser — reads Server-Sent Events from a ReadableStream.
 */

import type { ChatEvent } from '@skjv/common';

/**
 * Parse SSE events from a ReadableStreamDefaultReader.
 * Calls onEvent for each parsed event. Returns when stream is done.
 */
export async function parseSSEStream(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  onEvent: (event: ChatEvent) => void,
): Promise<void> {
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const chunks = buffer.split('\n\n');
    buffer = chunks.pop()!;
    for (const chunk of chunks) {
      const match = chunk.match(/^data: (.+)$/m);
      if (!match) continue;
      const event = JSON.parse(match[1]) as ChatEvent;
      onEvent(event);
    }
  }
}
